import { func } from "prop-types";
import styled from "styled-components/macro";
import { hideVisually, rem } from "polished";

import { colors } from "../../../styles/Styles.variables";

const PageSkip = props => <Skip {...props}>Skip to content</Skip>;

PageSkip.propTypes = {
  onClick: func,
};

const Skip = styled.button`
  ${hideVisually()};

  &:focus {
    background: ${colors.black};
    border: 0 none;
    clip: auto;
    clip-path: none;
    color: ${colors.white};
    display: block;
    height: auto;
    left: ${rem("4px")};
    line-height: 1;
    margin: 0;
    outline: ${rem("1px")} dotted ${colors.white};
    overflow: visible;
    padding: ${rem("3px")};
    position: absolute;
    top: ${rem("4px")};
    white-space: nowrap;
    width: auto;
    z-index: 5000;
  }
`;

export default PageSkip;
